import { Component, OnInit } from "@angular/core";
import { ToastrService } from "ngx-toastr";
import { GetCurrentShift } from "src/app/shared/Services/getCurrentShift";
import { DataService } from "src/app/shared/Services/data.service";

@Component({
  selector: "app-supervisor-mapping",
  templateUrl: "./supervisor-mapping.component.html",
  styleUrls: ["./supervisor-mapping.component.scss"],
})
export class SupervisorMappingComponent implements OnInit {
  currentShiftData: any;
  selectedSupervisors: { [key: string]: string } = {};
  breadCrumbItems: Array<{}>;
  userData: any;
  custId: any;
  departments: any = [];
  errmsg = "";
  selecteddepartmentName: any;
  usersData: any = [];
  supervisors: any = [];
  shiftsArr: any = [];
  timeZone: any;

  constructor(
    private toastr: ToastrService,
    private dataservice: DataService,
    private currShift: GetCurrentShift
  ) {}
  ngOnInit(): void {
    this.getUser();
    this.userData = JSON.parse(sessionStorage.getItem("currentUser"));
    this.custId = this.userData["user"]["custId"];
    this.breadCrumbItems = [
      { label: "Configuration" },
      { label: "Supervisor Mapping", active: true },
    ];
    this.getDepartment();
    this.getshiftDetails();
    this.userData = JSON.parse(sessionStorage.getItem("currentUser"));
    this.timeZone = this.userData["user"]["timeZone"];
  }

  getshiftDetails() {
    this.shiftsArr = [];
    this.dataservice.get(`api/shift`).subscribe((res) => {
      console.log(res, "res");
      if (res) {
        this.shiftsArr = res;
      }
    });
  }

  getUser() {
    this.supervisors = [];
    this.dataservice.get("api/user").subscribe((res) => {
      console.log(res);
      if (res) {
        this.usersData = res;
        this.supervisors = [
          { name: "Not Mapped",email :"Not Mapped" },
          ...this.usersData
            .filter((item) => item["role"] === "SUPERVISOR")
            .map((item) => ({ name: item.name,email :item.email})),
        ];
        console.log(this.supervisors, "this.supervisors");
      } else {
        this.supervisors = [];
        this.usersData = [];
      }
      (error) => {
        console.log(error);
        this.errmsg = "Server Unreachable";
        this.usersData = [];
        this.toastr.error("Server Unreachable");
      };
    });
  }

  // supervisors = [
  //   { name: "Not Mapped" },
  //   { name: "Supervisor - 1" },
  //   { name: "Supervisor - 2" },
  //   { name: "Supervisor - 3" },
  // ];

  departmentChange(data) {
    this.selecteddepartmentName = data;
    this.getDepartData();
  }
  getDepartment() {
    this.dataservice.get(`department`).subscribe((res: any) => {
      this.departments = res.data;
      console.log(this.departments,this.selecteddepartmentName, "departments");
      if(this.selecteddepartmentName){
        console.log(this.selecteddepartmentName, "if");
const data = this.selecteddepartmentName
        this.selecteddepartmentName =data
        console.log(this.selecteddepartmentName, "if");
      }else{
        console.log("else")

        this.selecteddepartmentName = this.departments[0].departmentName;
      }
      this.getDepartData();
    });
  }

  selectedDept: any;
  getDepartData() {
    this.selectedSupervisors = {};
    this.selectedDept = this.departments.find(
      (dept) => dept.departmentName === this.selecteddepartmentName
    );
    if (this.selectedDept && this.selectedDept.shiftData) {
      this.currentShiftData = this.currShift.getCurrentShift(
        this.selectedDept.shiftData,
        this.timeZone
      );
      console.log(this.currentShiftData, "if");
    } else {
      this.currentShiftData = this.currShift.getCurrentShift(
        this.shiftsArr,
        this.timeZone
      );
      console.log(this.currentShiftData, "else");
    }
    if (this.selectedDept && this.selectedDept.mappedData) {
      this.selectedDept.mappedData.forEach((shiftMap) => {
        const key = `${shiftMap.shiftName}`;
        this.selectedSupervisors[key] = shiftMap.supervisor;
      });
    }
  }
  onSupervisorChange(event: any, shiftName: string): void {
    console.log(shiftName, "shiftName");
    const supervisorName = event.target.value;
    const payload = {
      shiftName,
      supervisorName,
    };

    const department = this.departments.find(
      (d) => d.departmentName === this.selecteddepartmentName
    );
    if (department) {
      const shiftData = department.mappedData.find(
        (s) => s.shiftName === shiftName
      );
      if (shiftData) {
        shiftData.supervisor = supervisorName;
      }
    }

    this.toastr.success(
      `Supervisor is mapped to "${shiftName}" of "${this.selecteddepartmentName}"`
    );

    console.log("Payload:", payload, this.selectedDept);
    // const transformedPayload = this.transformPayload(payload);

    // console.log(transformedPayload, "transformedPayload");
    this.updateData(this.selectedDept);
  }

  // transformPayload(payload) {
  //   const { shiftName, supervisorName } = payload;
  //   const mappedData = this.selectedDept.mappedData.map((shift) => ({
  //     supervisor: shift.shiftName === shiftName ? supervisorName : "Not Mapped",
  //     shiftName: shift.shiftName,
  //   }));
  //   return {
  //     custId: this.custId,
  //     departmentName: this.selecteddepartmentName,
  //     mappedData: mappedData,
  //   };
  // }
  updateData(data) {
    this.dataservice
      .put(`mapping/supervisor/${this.selectedDept.id}`, data)
      .subscribe((res) => {
        console.log(res, "response");
        if (res) {
          this.departments=[]
          this.getDepartment();

        }
      });
  }
}
